import {
  ModalSeleccionBusquedaBody,
  ModalSeleccionBusquedaContainer,
  ModalSeleccionBusquedaFooter,
  ModalSeleccionBusquedaItem,
} from "./localStyle";

const ModalSeleccionBusqueda = ({ data, dismiss }) => {
  return (
    <ModalSeleccionBusquedaContainer>
      <ModalSeleccionBusquedaBody>
        {data.map((item, index) => (
          <ModalSeleccionBusquedaItem key={index}>
            <span>{item.particular && "PARTICULAR: "}</span>
            <span>{item.descripcion}</span>
          </ModalSeleccionBusquedaItem>
        ))}
      </ModalSeleccionBusquedaBody>
      <ModalSeleccionBusquedaFooter>
        <div className="ModalSeleccionBusqueda-btn" onClick={dismiss}>
          Continuar
        </div>
      </ModalSeleccionBusquedaFooter>
    </ModalSeleccionBusquedaContainer>
  );
};

export default ModalSeleccionBusqueda;
